import ApiService from "./api.service";

class AppError extends Error {
  constructor(errorCode, message) {
    super(message);
    this.name = this.constructor.name;
    this.message = message;
    this.errorCode = errorCode;
  }
}

const AppService = {
  /**
   * Fetch all countries, time zones currencies etc
   *
   * @returns array of countries,
   * @throws AppError
   **/
  pull: async function() {
    try {
      const response = await ApiService.get("/app");

      return response.data;
    } catch (error) {
      throw new AppError(error.response.status, error.response.data.detail);
    }
  },

  /**
   * Fetch country banks
   *
   * @returns array of banks,
   * @throws AppError
   **/
  fetchBanks: async function(countryId) {
    try {
      const response = await ApiService.get(
        `/app/countries/${countryId}/banks`
      );

      return response.data;
    } catch (error) {
      throw new AppError(error.response.status, error.response.data.detail);
    }
  },

  /**
   * Fetch country states
   *
   * @returns array of states,
   * @throws AppError
   **/
  fetchStates: async function(countryId) {
    try {
      const response = await ApiService.get(
        `/app/countries/${countryId}/states`
      );

      return response.data;
    } catch (error) {
      throw new AppError(error.response.status, error.response.data.detail);
    }
  },

  /**
   * Fetch state lgas
   *
   * @returns array of lgas,
   * @throws AppError
   **/
  fetchLgas: async function(countryId, stateId) {
    try {
      const response = await ApiService.get(
        `/app/countries/${countryId}/states/${stateId}/lgas`
      );

      return response.data;
    } catch (error) {
      throw new AppError(error.response.status, error.response.data.detail);
    }
  },
  requestFileUploadData: async function() {
    try {
      const response = await ApiService.get("/app/request-upload");

      return response.data;
    } catch (error) {
      throw new AppError(error.response.status, error.response.data.detail);
    }
  }
};

export { AppService, AppError };
